<template>
  <v-dialog
    v-model="dialog"
    width="400"
    content-class="confirmDialog"
  >
    <v-card class="text-center pa-8">
      <v-icon :color="color" v-if="icon">{{ icon }}</v-icon>
      <div class="my-6" v-html="message"></div>
      <div class="d-flex justify-center">
        <v-btn class="mx-4" @click="dialog = false">取消</v-btn>
        <v-btn class="mx-4 pink white--text" @click="func(); dialog = false">確定</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      func: null,
      message: '',
      icon: null,
      color: 'indigo'
    }
  },
  created() {
    this.$root.$on('confirmDialog', this.submit)
  },
  beforeDestroy() {
    this.$root.$off('confirmDialog', this.submit)
  },
  methods: {
    submit(func, message, icon, color) {
      this.dialog = true
      this.func = func
      this.message = message
      this.icon = icon
      this.color = color ? color : 'indigo'
    }
  }
}
</script>

<style lang="scss" scoped>
.confirmDialog {
  .v-icon {
    font-size: 80px;
  }
  .v-btn {
    width: 130px;
  }
  .v-card {
    color: $grey-2 !important;
  }
}
</style>